var React = require('react');

function Explore (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.15"},[React.createElement("path",{"d":"M1.00003 0.0249305L192 109.5L111.089 248.707L1.00003 0.0249305Z","fill":"#FECD8B","key":0}),React.createElement("path",{"d":"M111.089 248.682L192 109.475L383 219L192 328.525L1.00003 438L111.089 248.682Z","fill":"#FEEACE","key":1}),React.createElement("path",{"d":"M111.082 248.682L0.993553 438L0.993556 219L0.993558 -1.38699e-06L111.082 248.682Z","fill":"#FDAB3D","key":2})]));
}

Explore.defaultProps = {"width":"383","height":"438","viewBox":"0 0 383 438","fill":"none"};

module.exports = Explore;

Explore.default = Explore;
